module.exports = __webpack_public_path__ + "img/other2.1d77701c.png";